export function formatDateToLong(dateInput, withTime = false) {
  if (!dateInput) return "";
  const date = typeof dateInput === "string" || typeof dateInput === "number"
    ? new Date(dateInput)
    : dateInput;
  if (isNaN(date)) return "";
  if (withTime) {
    // Example: 23 June 2025 12:22 AM
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    }).replace(",", "");
  }
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
}
